import { render, staticRenderFns } from "./dialog-createrelationoutbox.vue?vue&type=template&id=7eda0038&"
import script from "./dialog-createrelationoutbox.vue?vue&type=script&lang=js&"
export * from "./dialog-createrelationoutbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports